"use strict";
/**
 * 期货自定义表格
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.custom_qhtable = void 0;
var config_1 = require("../../modules/qihuo/config");
exports.custom_qhtable = {
    qihuo_small: [
        { title: '序号', value: 'rank' },
        { title: '代码', value: config_1.QiHuoItem.代码带链接 },
        { title: '名称', value: config_1.QiHuoItem.行情统一链接 },
        { title: '最新价', value: config_1.QiHuoItem.最新价 },
        { title: '涨跌额', value: config_1.QiHuoItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QiHuoItem.涨跌幅 },
        { title: '所属交易所', value: config_1.QiHuoItem.市场名称 },
    ],
};
